import React from "react";
import { view } from "@risingstack/react-easy-state";

const ChatIcon = view(({ unreadCount = 0, onClick, isUploading = false }) => {
  return (
    <div className="chat-icon-overlay" onClick={onClick}>
     
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1a73e8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      {unreadCount > 0 && <div className="unread-badge">{unreadCount}</div>}
    </div>
  );
});

export default ChatIcon;
